import { sipExtensionDndResponseSchema, sipExtensionDndStateSchema, type SipExtensionReadDto } from '@easyflow/shared';

interface DndFeedback {
  type: 'success' | 'warning';
  message: string;
  savedEnabled: boolean | undefined;
}

export function getSipExtensionSaveFeedback(saved: SipExtensionReadDto | undefined, description: string): {
  title: string; description: string; duration?: number;
} {
  if (!saved?.freeswitch_update) return { title: 'Successo!', description };
  const feedback = getSipExtensionDndFeedback(saved);
  return {
    title: feedback.type === 'warning' ? 'Interno salvato con avviso' : 'Successo!',
    description: `${description}. ${feedback.message}`,
    ...(feedback.type === 'warning' ? { duration: 8000 } : {}),
  };
}

export function getSipExtensionDndFeedback(data: unknown): DndFeedback {
  const saved = sipExtensionDndStateSchema.safeParse(data);
  if (!saved.success) {
    return {
      type: 'warning', savedEnabled: undefined,
      message: 'Esito DND non confermato. Ricarica lo stato prima di riprovare.',
    };
  }
  const prefix = `Preferenza DND ${saved.data.dnd_enabled ? 'attiva' : 'disattiva'} salvata.`;
  const parsed = sipExtensionDndResponseSchema.safeParse(data);
  if (!parsed.success) {
    return {
      type: 'warning', savedEnabled: saved.data.dnd_enabled,
      message: `${prefix} Il dettaglio dell’aggiornamento delle code non è disponibile. Verifica lo stato prima di riprovare.`,
    };
  }
  const outcome = parsed.data.freeswitch_update;
  if (outcome.state === 'command_accepted') {
    return {
      type: 'success', savedEnabled: saved.data.dnd_enabled,
      message: `${prefix} FreeSWITCH ha accettato l’aggiornamento dello stato nelle code.`,
    };
  }
  if (outcome.state === 'not_applied') {
    const reason: Record<typeof outcome.reason, string> = {
      tenant_unavailable: 'Impossibile risolvere il tenant: aggiornamento dello stato nelle code non eseguito.',
      node_unavailable: 'Nodo FreeSWITCH non disponibile: aggiornamento dello stato nelle code non eseguito.',
      command_rejected: 'FreeSWITCH ha rifiutato l’aggiornamento dello stato nelle code.',
    };
    return { type: 'warning', savedEnabled: saved.data.dnd_enabled, message: `${prefix} ${reason[outcome.reason]}` };
  }
  return {
    type: 'warning', savedEnabled: saved.data.dnd_enabled,
    message: `${prefix} ${outcome.reason === 'timeout' ? 'Tempo di attesa scaduto: esito' : 'Esito'} dell’aggiornamento dello stato nelle code non confermato. Verifica lo stato prima di riprovare.`,
  };
}
